const TABLE_FIELD_NAMES = {
  CONTRACT_TYPES: 'contractTypes',
  CONTRACT_STATUS: 'contractStatus',
  CONTRACT_DATE: 'contractDate'
};

export default TABLE_FIELD_NAMES;
